export const PROFILE_DATA = 'prfdt'
export const ACCESS_TOKEN_TTL = 'atttl'
export const REFRESH_TOKEN_TTL = 'rtttl'